import CompleteInspectionPage from './components/CompleteInspectionPage';

export default CompleteInspectionPage;